import React from 'react'
import '../stylesheets/aboutMe.sass'
import Content from '../Contents.json'
import me from '../img/me.jpeg'
import piano from '../img/piano-placeholder.jpg'
import dev from '../img/dev.png'

class AboutMe extends React.Component {

	constructor (props) {
		super(props)
		this.state = {
			meShown: false,
			musicShown: false,
			designShown: false,
			language: props.language
		}

		this.showPopup = props.showPopup

	}

	componentWillReceiveProps (props) {
		this.setState({language: props.language})
	}

	componentDidMount() {
    	window.addEventListener('scroll', this.handleScroll, true);
  	}

  	componentWillUnmount() {
    	window.removeEventListener('scroll', this.handleScroll);
  	}

	render () {

		var content = this.state.language === "de" ? Content.de.aboutyou : Content.en.aboutyou

		var body = (<div className="Container white f1st">
				<div className="Content">
					<div className="tile">
						<img src={me} alt="Tim Patrick Kakucs" />
						<div>
							<h2>{content[0].title}</h2>
							<p>{content[0].content}</p>
							<button onClick={() => {this.showPopup("mail")}}>{content[0].button}</button>
						</div>
					</div>
					<div className="tile reversed">
						<div>
							<h2>{content[1].title}</h2>
							<p>{content[1].content}</p>
							<button onClick={() => {this.showPopup("mail")}}>{content[1].button}</button>
						</div>
						<img src={dev} alt="Xcode Screenshot" />
					</div>
					<div className="tile last">
						<img src={piano} alt="Grand Piano" />
						<div>
							<h2>{content[2].title}</h2>
							<p>{content[2].content}</p>
							<button onClick={() => {this.showPopup("instagram")}}>{content[2].button}</button>
						</div>
					</div>
				</div>
			</div>)

		return body
	}

	handleScroll = () => {
		
	}

}

export default AboutMe